import {Container} from 'react-bootstrap';
import {Row} from 'react-bootstrap';
import {Col} from 'react-bootstrap';
import logo from './vidhur.png';



function About(){
    
     //const iconColor = {color:"tomato"};

   return(
   <div className="About-content">
        <Container >

            <div className="about-head" id="about">
                <h2>Who Am I?</h2>
                <hr className="about-line"/>
            </div>

  <Row className="about-row">
    <Col xs={12} md={5}>
            <div className="pic">
               <img src={logo} width="280px" className="ml-3 mb-2" alt="person"/>
            </div>
    </Col>
    <Col xs={12} md={7}>
    <div className="about-intro">
              <p>
              A passionate <span className="about-span">Web Developer, Photographer and a Graphic Designer</span>.<br/>
I've developed small-scale as well as large-scale web applications.<br/>
Started as a <span className="about-span">Nature Photographer</span>, and then jumped into other types of Photography.
So far, so good and I'm looking forward to learn more & more <br/><span className="about-span">Tools & Technologies</span> and keep myself updated.
              </p> 
     </div>
    </Col>
  </Row>

</Container>
  </div>
);
}

export default About;